module.exports = __webpack_public_path__ + "static/img/wood11.48c780e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood11.jpg
// module id = lq86
// module chunks = 0